<div class="container-fluid" id="sensor-detail">
    <div *ngIf="!isEditSensor" id="sensor-information" class="sensor-detail-info-column">
        <div id="general-sensor-information">
            <h1>{{ sensor.name }}</h1>
            <span>Sensor type: {{ sensor?.sensorType?.description }}</span>

            <h1>
                General information
                <a *ngIf="this.rights.get('update')" (click)="onEditClick()">
                    <i id="edit-sensor-button" class="fa fa-pencil"></i>
                </a>
            </h1>
            <span id="sensor-instrument-type">Instrument type: {{ sensor.instrumentType }}</span>
            <span id="sensor-location">Location: {{ sensor.locationName }}</span>
            <span>Start date sensor operational: {{ sensor.startDate | date: "dd/MM/yyyy" }}</span>
            <span>End date sensor operational: {{ sensor.endDate | date: "dd/MM/yyyy" }}</span>
        </div>
        <div id="location-table-wrapper">
            <h1>Coordinates of sensor and feature(s)</h1>
            <a *ngIf="this.rights.get('update')" id="edit-coordinates-button" (click)="locationModal.addFeature();">
                + Add measurement location
            </a><br/>
            <table id="location-table">
                <tr>
                    <th>Sensor Location Name<br/>Feature Name</th>
                    <th>Type</th>
                    <th>Active</th>
                    <th>End date</th>
                    <th>X-position<br/>RD</th>
                    <th>Y-position<br/>RD</th>
                    <th>Z-position<br/>NAP in M</th>
                    <th *ngIf="this.rights.get('update')"></th>
                </tr>
                <tr id="sensor-row">
                    <td>{{ sensor.locationName }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{ sensor.x }}</td>
                    <td>{{ sensor.y }}</td>
                    <td>{{ sensor.z }}</td>
                    <td *ngIf="this.rights.get('update')"><i id="edit-sensor-location-button" class="fa fa-pencil"
                                                             (click)="locationModal.editSensor(sensor);"></i>
                    </td>
                </tr>
                <tr *ngFor="let feature of this.features; let i = index" [ngClass]="'feature' + i">
                    <td class="feature-name">{{ feature.name }}</td>
                    <td class="feature-type">{{ feature.featureType.name }}</td>
                    <td class="feature-active"><i
                            [ngClass]="(feature.active === undefined || feature.active) ? 'fa fa-check' : 'fa fa-ban'"></i></td>
                    <td class="feature-end-date">{{ feature.endDate | date: "dd/MM/yyyy" }}</td>
                    <td class="feature-x-coordinate">{{ feature.x }}</td>
                    <td class="feature-y-coordinate">{{ feature.y }}</td>
                    <td class="feature-z-coordinate">{{ feature.z }}</td>
                    <td *ngIf="this.rights.get('update')"><i id="edit-feature-button-{{i}}" class="fa fa-pencil" aria-hidden="true"
                                                             (click)="locationModal.editFeature(feature);"></i>
                    </td>
                </tr>
            </table>
        </div>
    </div>

    <div *ngIf="isEditSensor" id="edit-sensor" class="sensor-detail-info-column">
        <form [formGroup]="updateSensorForm">
            <label>
                Instrument type
                <input id="edit-instrument-type" type="text" formControlName="instrumentType" [maxlength]="255"/><br/>
                <div *ngIf="updateSensorFormController.instrumentTypeControl.invalid" class="text-danger">
                    <div *ngIf="updateSensorFormController.instrumentTypeControl.errors['required']">
                        {{ validatorMessage.Required }}
                    </div>
                </div>
            </label>
            <label>
                Location
                <input id="edit-location" type="text" formControlName="locationName" [maxlength]="40"/><br/>
                <div *ngIf="updateSensorFormController.locationNameControl.invalid" class="text-danger">
                    <div *ngIf="updateSensorFormController.locationNameControl.errors['required']">
                        {{ validatorMessage.Required }}
                    </div>
                </div>
            </label>

            <div class="row">
                <div class="col-md-6">
                    <label>
                        Start date sensor operational
                        <input type="date"
                               class="custom-text-input"
                               id="edit-start-date"
                               formControlName="startDate"
                               [ngClass]="{'placeholder-date': !updateSensorFormController.startDateControl.value}"
                        />
                        <div *ngIf="updateSensorFormController.startDateControl.invalid" class="text-danger">
                            <div *ngIf="updateSensorFormController.startDateControl.errors['required']">
                                {{ validatorMessage.Required }}
                            </div>
                        </div>
                    </label>
                </div>
                <div class="col-md-6">
                    <label>
                        End date sensor operational
                        <input type="date"
                               class="custom-text-input"
                               id="edit-end-date"
                               formControlName="endDate"
                               [ngClass]="{'placeholder-date': !updateSensorFormController.endDateControl.value}"
                        />
                        <div *ngIf="updateSensorFormController.endDateControl.invalid" class="text-danger">
                            <div *ngIf="updateSensorFormController.endDateControl.errors['invalidEndDate']">
                                {{ validatorMessage.InvalidEndDate }}
                            </div>
                        </div>
                    </label>
                </div>
            </div>

            <div id="edit-sensor-buttons">
                <input class="btn save-button" id="save-sensor-button" type="submit" value="save"
                       [disabled]="updateSensorForm.invalid || saving" (click)="onSubmitSensorChanges()"/>
                <input class="btn cancel-button" id="cancel-save-sensor-button" type="submit" value="cancel" [disabled]="saving"
                       (click)="onCancelClick()"/>
            </div>
        </form>
    </div>

    <div id="device-information " class="sensor-detail-device-column">
        <ng-container *ngIf="device; else noDevice">
            <h1>Connected to device</h1>
            <span id="sensor-device-id">
        Device ID: {{ device.deviceId }}
      </span>
            <span id="sensor-gateway-id">
        Gateway ID: {{ device.gatewayId }}
      </span>
            <span id="sensor-gateway-type">
        Gateway Type: {{ device.gatewayTypeId }}
      </span>
            <span id="sensor-device-location">
        Location: {{ device.location }}
      </span>
            <span id="sensor-device-date-added">
        Date Added: {{ device.dateAdded | date: "dd/MM/yyyy" }}
      </span>
        </ng-container>
        <ng-template #noDevice>
            <div class="alert alert-warning">
                <h1><i class="fa fa-warning fa-fw"></i> Device data unavailable</h1>
            </div>
        </ng-template>
    </div>
</div>

<app-update-feature #locationModal [sensor]="sensor">
</app-update-feature>
